import React from "react";
import styled from "styled-components";
import { ScorecardIcon } from "../../../assets/svg/ScorecardIcon";
import { TitleText, LabelText } from "../../../ui/Text";
import { get } from "../../../utils/get";

interface InfoItemProps {
  icon: JSX.Element;
  title: string;
  label: string;
}

const InfoItem = ({ icon, label, title }: InfoItemProps) => (
  <InfoSection>
    {icon}
    <TitleText>{title}</TitleText>
    <LabelText>{label}</LabelText>
  </InfoSection>
);

export const StrategymapInfo = ({ strategymapData }: any) => {
  return (
    <StrategymapInfoContainer>
      <InfoItem
        icon={<ScorecardIcon isActive />}
        label={get(strategymapData, "[0].name")}
        title="Strategy Map"
      />
      <InfoItem
        icon={<ScorecardIcon isActive />}
        label="Scope"
        title="Company A"
      />
      <InfoItem
        icon={<ScorecardIcon isActive />}
        label={get(strategymapData, "[0]mission")}
        title="Mission"
      />
      <InfoItem
        icon={<ScorecardIcon isActive />}
        label={get(strategymapData, "[0]vision")}
        title="Vision"
      />
    </StrategymapInfoContainer>
  );
};

const StrategymapInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 2fr;
  grid-column-gap: 2em;
  padding: 2em;
  border-bottom: 1px solid #ebeeff;
`;
const InfoSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-template-rows: 1em auto;
  grid-row-gap: 1.5em;
  align-items: center;
  ${LabelText} {
    display: grid;
    grid-column-start: 1;
    grid-column-end: 3;
    align-self: flex-start;
    max-height: 5em;
    overflow-y: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
  }
`;
